import axiosInstance from "@/api/axiosInstance";
import type {
  FinalizeEventSessionRequest,
  FinalizeEventSessionResponse,
} from "./types";

export const finalizeEventSession = async ({
  uuid,
}: FinalizeEventSessionRequest): Promise<FinalizeEventSessionResponse> => {
  const response = await axiosInstance.post<{
    data: FinalizeEventSessionResponse;
  }>("/api/private/event-sessions/finalize", { uuid });
  return response.data.data;
};
